// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedCarouselStyles } from "@eisinc/App/SharedStyles/ProductCarouselStyles";
import { productGridCardStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { color, customBadgesStyles, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

productGridCardStyles.productGridContainerStyles = {
    container: {
        css: css`
            &&&& {
                max-width: initial;
            }
        `,
    },
    image: {
        css: css`
            min-width: 100%;
            max-width: 100%;
            min-height: 100%;
            max-height: 100%;
        `,
    },
};

productGridCardStyles.productMiniCardContainer = {
    ...sharedCarouselStyles.miniCardStyles?.productGridContainerStyles,
    container: {
        css: css`
            ${sharedCarouselStyles.miniCardStyles?.productGridContainerStyles?.container?.css}
            &&&& {
                max-width: initial;
                padding: 12px 0;
                border-bottom: 1px solid ${color("common.border")};
                ${xScreen("lte", "md")} {
                    &:first-child,
                    &:nth-child(2) {
                        padding: 0 0 12px;
                    }
                }
                ${xScreen("lt", "sm")} {
                    &:nth-child(2) {
                        padding: 12px 0;
                    }
                }
            }
        `,
    },
    image: {
        css: css`
            ${sharedCarouselStyles.miniCardStyles?.productGridContainerStyles?.image?.css}
            min-width: 100%;
            max-width: 100%;
            min-height: 100%;
            max-height: 100%;
        `,
    },
};

productGridCardStyles.productInformationStyles = {
    container: {
        gap: 8,
        css: css`
            height: 100%;
        `,
        offsetCss: css`
            height: 100%;
        `,
    },
    descriptionGridItem: { width: 12 },
    partNumbersGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            gap: 2px;
        `,
    },
};

productGridCardStyles.badgesContainerStyle = {
    css: css`
        ${({ view }: any) =>
            view !== "miniCard"
                ? css`
                      position: absolute;
                      bottom: 4px;
                      left: 4px;
                  `
                : css`
                      margin-top: auto;
                  `}

        ${customBadgesStyles.container.css}
    `,
};

productGridCardStyles.productListImageStyles = {
    productImage: {
        linkWrappingImage: {
            css: css`
                width: 100%;
                height: 100%;
                justify-content: center;
            `,
        },
    },
};
